import { formatPhoneNumber } from 'react-phone-number-input'
import type { TPatient } from 'src/types/patient'
import type { TFunction } from 'i18next'

const formatPhoneToInternational = (phoneNumber?: string | null) => {
  return phoneNumber?.length ? `+${phoneNumber.replace(/\+/, '')}` : undefined
}

const formatPhone = (phoneNumber: string) => {
  return formatPhoneNumber(`+${phoneNumber.replace(/\+/, '')}`)
}

const getPhone = (t: TFunction, phoneNumber?: string | null) => {
  return phoneNumber ? formatPhone(phoneNumber) : t('components.patient-phone.missing-phone')
}

const getPhoneAndCaregiver = ({
  t,
  patient,
}: {
  t: TFunction
  patient: Pick<TPatient, 'phone' | 'hasCaregiver'>
}) => {
  const phone = formatPhone(patient.phone) || patient.phone
  if (patient.hasCaregiver) {
    return `${phone} ${t('components.patient-phone.caregiver-number')}`
  }
  return phone
}

export { formatPhone, getPhone, getPhoneAndCaregiver, formatPhoneToInternational }
